import { FC } from 'react';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import './line-items.css';

import { Button } from '../button';

export interface LineItemFooterProps {
	totalAmount: string;
	currencySymbol: string;
	hasFields: boolean;
	onClickAddLineItem?: () => void;
}

export const LineItemFooter: FC<LineItemFooterProps> = (props: LineItemFooterProps) => {
	const { t: translate } = useTranslation();
	const { totalAmount, currencySymbol, onClickAddLineItem, hasFields } = props;
	const buttonShown = hasFields || onClickAddLineItem;
	return (
		<div className={clsx(buttonShown && 'line-items-footer', hasFields && 'line-items-footer-space-between')}>
			{hasFields && (
				<div>
					<span className="line-items-total">
						<span>{translate('lineItem.total')}</span>
						<span className="line-items-total-amount">{`${currencySymbol}${totalAmount}`}</span>
					</span>
				</div>
			)}
			{onClickAddLineItem && (
				<Button
					className={clsx('line-item-add-btn', hasFields && 'line-item-add-btn-small')}
					label={
						<div className="line-item-add-btn-text">
							<span>{translate(hasFields ? 'lineItem.addAnother' : 'lineItem.addFund')}</span>
						</div>
					}
					variant="secondary"
					onClick={onClickAddLineItem}
				/>
			)}
		</div>
	);
};
